import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from 'assets/images/logoLetrus.svg';
import Navbar from '../Navbar';
import SideBar, { MenuItem, Theme } from '../SideBar';
import styles from './PageWrapper.module.scss';

export interface PageWrapperProps {
  topMenu: MenuItem[];
  bottomMenu?: MenuItem[];
  theme: Theme;
  centerComponent?: React.ReactNode;
  rightComponent: React.ReactNode;
  children: React.ReactNode;
  userRole?: string;
  isMenuButtonDisabled?: boolean;
}

function PageWrapper({
  topMenu,
  theme,
  rightComponent,
  bottomMenu,
  children,
  centerComponent,
  isMenuButtonDisabled,
  userRole = 'anonymous',
}: PageWrapperProps): React.ReactElement {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const navbarLeftComponent = (
    <button
      type="button"
      disabled={isMenuButtonDisabled}
      className={`${styles.menuButton} ${
        isMenuButtonDisabled ? styles.disabledMenuButton : ''
      }`}
      onClick={() => setIsSidebarOpen((isOpen) => !isOpen)}
      data-testid="menuButton"
    >
      <FontAwesomeIcon icon="bars" size="lg" color="#3C405F" />
    </button>
  );

  return (
    <div className={styles.wrapper}>
      <Navbar
        leftComponent={navbarLeftComponent}
        centerComponent={
          centerComponent ?? <img alt="Logo Letrus" src={Logo} />
        }
        rightComponent={rightComponent}
      />

      <div className={styles.body}>
        <SideBar
          topMenu={topMenu}
          bottomMenu={bottomMenu}
          closed={!isSidebarOpen}
          theme={theme}
          userRole={userRole}
        />

        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}

export default PageWrapper;
